<template>
  <div class="CardBasicInfoBlock">
    <CardBasicInfoTitle>
      {{ data.name ? data.name[selectedLanguage] : '' }}
    </CardBasicInfoTitle>
    <CardBasicInfoThumbnail :image="data.thumbnail" />
    <CardBasicInfoTitle>
      {{ data.title[selectedLanguage] }}
    </CardBasicInfoTitle>
    <CardBasicInfoAction @clicked="data.action">
      {{ data.actionText }}
    </CardBasicInfoAction>
  </div>
</template>

<script>
import CardBasicInfoThumbnail from '@/components/cardBasicInfo/Thumbnail.vue';
import CardBasicInfoTitle from '@/components/cardBasicInfo/Title.vue';
import CardBasicInfoAction from '@/components/cardBasicInfo/Action.vue';

export default {
  name: 'CardBasicInfoBlock',
  components: {
    CardBasicInfoThumbnail,
    CardBasicInfoTitle,
    CardBasicInfoAction,
  },
  props: {
    data: {
      type: Object,
      required: true,
    },
  },
  computed: {
    selectedLanguage() {
      console.log(this.data.name);
      return this.$i18n.locale();
    },
  },
};
</script>
